import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IMyMonitoringCompleteUserModel } from '@apps-common/types/portal/users'

export const QUERY_GET_UNIT_SITE_USERS = (unitId?: string) => ['getUnitSiteUsers', unitId].filter(Boolean)

const getUnitSiteUsers = async (unitId: string): Promise<IMyMonitoringCompleteUserModel> =>
  axios.get(`/unit/getusers?unitId=${unitId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitSiteUsers

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId: string
}

export const useGetUnitSiteUsers = ({ config, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_GET_UNIT_SITE_USERS(unitId),
    queryFn: () => getUnitSiteUsers(unitId)
  })
